chat:
  actions:
    retry: 重试
  message:
    character-name:
      airi: AIRI
      core-system: 核心系统
      you: 你
  reasoning: 思考
  sessions:
    title: 对话
    new: + 新建
    empty: 暂无对话
    cloud-badge: 已同步到云
    new-chat-fallback: 新建对话
    delete: 删除对话
message: 说点什么...
send-mode:
  title: 发送键值
  enter: Enter
  ctrl-enter: Ctrl + Enter
  double-enter: 双击Enter
operations:
  load-models: 加载模型
  load-models-status:
    loading: 模型加载中
    ready: 已就绪
select-a-audio-input: 选择一个音频输入设备
select-a-model: 选择一个模型
select-a-voice: 选择一个声线
viewers:
  debug-menu:
    emotions: 表情
    emotions-btn:
      angry: '😠 生气'
      awkward: '😳 尴尬'
      happy: '😄 开心'
      neutral: '🙂 日常'
      question: '🤔 疑问'
      sad: '😫 难过'
      surprised: '🤯 惊喜'
      think: '🤨 思考'
    vrm:
      camera: 摄像机
      model:
        title: 模型
profile-switcher:
  no-profile: 缺少角色
  no-profiles: 还没有角色
  save-as-new: 存为新角色
  new-profile-name: 角色卡名称
  manage: 管理角色卡
promo-banner:
  items:
    signin:
      watermark: 月石
      fallbackLabel: 月石礼包
      title: 7日签到
      eventName: 登录后可以申请星尘、头像框和登录礼物。
      date: 03/28 - 04/10
      reward: 最多120个星尘
      cta: 登录
    build:
      watermark: Build
      fallbackLabel: Build Bonus
      title: Supply Box Bonus
      eventName: Finish construction tasks to earn bonus vouchers and double materials.
      date: 03/30 - 04/12
      reward: 5 Supply Vouchers + Upgrade Materials
      cta: 查看任务
    spring:
      watermark: Spring
      fallbackLabel: Spring Draw
      title: Capsule Carnival
      eventName: Join the spring draw to unlock bubbles, charms, and themed furniture.
      date: 04/01 - 04/18
      reward: Half-Price First Pull + Rare Charm
      cta: Draw Now
    coupon:
      watermark: 对话
      fallbackLabel: 优惠券
      title: 充值优惠券
      eventName: Finish chat interactions to claim coupons for expansion and voice packs.
      date: 04/02 - 04/20
      reward: Save 6 on 30 / Save 15 on 68
      cta: 领取优惠券
    home:
      watermark: 首页
      fallbackLabel: 房间主题
      title: Spring Theme Update
      eventName: Unlock window, desk, and night-lamp themes to refresh your room.
      date: 04/05 - 04/22
      reward: Free Theme Draw Ticket on Sign-in
      cta: 查看主题
waiting: 等待中
websocket-status:
  connected: 已连接
  disconnected: 无网络连接
  open-settings: 打开连接设置
